module.exports = __webpack_public_path__ + "static/img/lj6.6ab1091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj6.png
// module id = Tt+t
// module chunks = 3